import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';
import { TAgentFirmResponse } from './types';

type UseAgentFirmOptions = {
  agentFirmId: string;
  enabled?: boolean;
};

export function useAgentFirm(options: UseAgentFirmOptions) {
  const { agentFirmId, enabled = true } = options;

  const url = `${API_BASE_PATH}/${agentFirmId}`;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: TAgentFirmResponse;
    error?: unknown;
    mutate: KeyedMutator<TAgentFirmResponse>;
    isLoading: boolean;
  } = useSWR(
    enabled && agentFirmId ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.agentFirm,
    error,
    mutate,
    isLoading,
  };
}
